import { css, html } from "lit"
import { MODE_CONNEXION, MODE_INSCRIPTION } from "../connexion/Connexion.js"
import "@luminecence/composants/ChampMotDePasse"
import "@luminecence/composants/LibelleChamp"
import PopupBase from "@luminecence/composants/PopupBase"

const CODE_ERREUR_FORMULAIRE = {
  ERREUR_PSEUDO: 0,
  ERREUR_EMAIL: 1,
  ERREUR_MOT_DE_PASSE: 2,
  AUTRE: 99,
}

export default class PopupConnexion extends PopupBase {
  static properties = { erreur: { type: String }, mode: { type: String } }

  static styles = [
    PopupBase.styles,
    css`
    :host .conteneur .oubli-mot-de-passe {
      background-color: transparent;
      border: none;
      color: var(--couleur-lien);
      text-decoration: underline;
      cursor: pointer;
      align-self: flex-end;
      font-size: 1.5rem;
    }

    :host .conteneur .formulaire {
      padding: 0.5rem;
    }

    .separateur {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    .separateur::before,
    .separateur::after {
      content: "";
      flex: 1;
      height: 1px;
      background-color: var(--couleur-texte);
    }

    .conteneur-logo {
      display: flex;
      align-items: center;
      gap: 1rem;
      cursor: pointer;
      width: fit-content;
      background-color: transparent;
      border: none;
      color: inherit;
      font-size: 1.5rem;
    }

    .conteneur-logo .logo {
      width: 24px;
    }
  `,
  ]

  constructor() {
    super()
    this.email = ""
    this.motDePasse = ""
    this.pseudo = ""
    this.mode = MODE_CONNEXION
    this.erreur = []
  }

  render() {
    return html`<div class="conteneur">
                <h1>${this.mode === MODE_CONNEXION ? "Se connecter" : "Créer un compte"}</h1>
                ${this.genererTemplateErreur()}
                <div class="formulaire">
                    <span>${this.mode === MODE_CONNEXION ? "Se connecter" : "S'inscrire"} avec un mail et un mot de passe</span>
                    <p-libelle-champ libelle="email" type="email" id-input="email" .valeur=${this.email} .required=${true} @evenementChangerValeurChamp=${this.changerEmail}></p-libelle-champ>
                    <div class="libelle-champ"><label>mot de passe</label><p-champ-mot-de-passe id="mot-de-passe" @evenementChangerMotDePasse=${this.changerMotDePasse}></p-champ-mot-de-passe></div>
                    ${
                      this.mode === MODE_INSCRIPTION
                        ? html`<p-libelle-champ libelle="pseudo" type="text" id-input="pseudo" .valeur=${this.pseudo} @evenementChangerValeurChamp=${this.changerPseudo}></p-libelle-champ>`
                        : html`<button class="oubli-mot-de-passe" @click=${this.reinitialiserMotDePasse}>Mot de passe oublié ?</button>`
                    }
                <div class="separateur"><span>ou</span></div>
                    <button class="conteneur-logo" @click=${this.seConnecterAvecGoogle}><img class="logo" src="../../images/logo_google.png" alt="Google logo"><span>Se connecter avec Google</span></button>
                    <button class="conteneur-logo" @click=${this.seConnecterAvecMicrosoft}><img class="logo" src="../../images/logo_microsoft.png" alt="Microsoft logo"><span>Se connecter avec Microsoft</span></button>
                    <button class="conteneur-logo" @click=${this.seConnecterAvecDiscord}><img class="logo" src="../../images/logo_discord.png" alt="Discord logo"><span>Se connecter avec Discord</span></button>
                </div>
            </div>
                ${this.renderBoutons()}`
  }

  async seConnecterAvecGoogle() {
    try {
      console.log("Tentative de connexion avec Google...")
      // signInWithPopup ouvre directement un popup, pas de redirection
      // Le résultat est retourné immédiatement
      await window.authentification.connecterUtilisateurAvecGoogle()
      console.log("Connexion Google réussie")
      this.dispatchEventEtFermerPopup({ pseudo: window.authentification.getUser().displayName })
    } catch (error) {
      console.error("Erreur lors de la connexion avec Google:", error)
      this.erreur = [{ code: CODE_ERREUR_FORMULAIRE.AUTRE, message: error.message }]
    }
  }

  async seConnecterAvecMicrosoft() {
    try {
      console.log("Tentative de connexion avec Microsoft...")
      // signInWithPopup ouvre directement un popup, pas de redirection
      // Le résultat est retourné immédiatement
      await window.authentification.connecterUtilisateurAvecMicrosoft()
      console.log("Connexion Microsoft réussie")
      this.dispatchEventEtFermerPopup({ pseudo: window.authentification.getUser().displayName })
    } catch (error) {
      console.error("Erreur lors de la connexion avec Microsoft:", error)
      this.erreur = [{ code: CODE_ERREUR_FORMULAIRE.AUTRE, message: error.message }]
    }
  }

  async seConnecterAvecDiscord() {
    try {
      console.log("Tentative de connexion avec Discord...")
      // signInWithPopup ouvre directement un popup, pas de redirection
      // Le résultat est retourné immédiatement
      const pseudo = await window.authentification.connecterUtilisateurAvecDiscord()
      console.log("Connexion Discord réussie")
      this.dispatchEventEtFermerPopup({ pseudo })
    } catch (error) {
      console.error("Erreur lors de la connexion avec Discord:", error)
      this.erreur = [{ code: CODE_ERREUR_FORMULAIRE.AUTRE, message: error.message }]
    }
  }

  genererTemplateErreur() {
    return this.erreur ? html`<span class="erreur">${this.genererErreurs()}</span>` : ""
  }

  genererErreurs() {
    if (this.erreur.length === 0) {
      return ""
    }

    return html`<div class="erreur">${this.erreur.map((err) => html`<p>${err.message}</p>`)}</div>`
  }

  reinitialiserMotDePasse() {
    if (this.email.trim() === "") {
      this.erreur = ["Veuillez entrer votre email pour réinitialiser le mot de passe"]
      return
    }

    window.authentification.reinitialiserMotDePasse(this.email)
  }

  /**
   * valide le formulaire
   * @returns {Boolean}
   */
  validerFormulaire() {
    this.erreur = []
    if (this.mode === MODE_INSCRIPTION && this.pseudo.trim() === "") {
      this.erreur.push({
        code: CODE_ERREUR_FORMULAIRE.ERREUR_PSEUDO,
        message: "Le pseudo est obligatoire",
      })
    }

    if (this.email.trim() === "") {
      this.erreur.push({
        code: CODE_ERREUR_FORMULAIRE.ERREUR_EMAIL,
        message: "L'email est obligatoire",
      })
    }

    if (this.motDePasse.trim() === "") {
      this.erreur.push({
        code: CODE_ERREUR_FORMULAIRE.ERREUR_MOT_DE_PASSE,
        message: "Le mot de passe est obligatoire",
      })
    }

    if (this.motDePasse.length < 6) {
      this.erreur.push({
        code: CODE_ERREUR_FORMULAIRE.ERREUR_MOT_DE_PASSE,
        message: "Le mot de passe doit contenir au moins 6 caractères",
      })
    }

    return this.erreur.length === 0
  }

  async valider() {
    if (this.validerFormulaire()) {
      try {
        if (this.mode === MODE_CONNEXION) {
          await window.authentification.connecterUtilisateur(this.email, this.motDePasse)
          this.pseudo = window.authentification.getUser().displayName
        } else if (this.mode === MODE_INSCRIPTION) {
          await window.authentification.inscrireUtilisateur(this.email, this.motDePasse, this.pseudo)
          await window.authentification.bdd.membres.ajouterUnMembre(this.pseudo, window.authentification.getUser().uid, this.email)
        }
      } catch (error) {
        this.erreur = [{ code: CODE_ERREUR_FORMULAIRE.AUTRE, message: error.message }]
        return
      }
      this.dispatchEventEtFermerPopup({ pseudo: this.pseudo })
    }
  }

  annuler() {
    this.dispatchEventEtFermerPopup(false)
  }

  dispatchEventEtFermerPopup(detail) {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: detail,
      }),
    )
    this.fermerPopup()
  }

  changerEmail(event) {
    this.email = event.detail?.valeur ?? event.target.value
  }

  changerMotDePasse(event) {
    this.motDePasse = event.detail.motDePasse
  }

  changerPseudo(event) {
    this.pseudo = event.detail?.valeur ?? event.target.value
  }
}
customElements.define("p-popup-connexion", PopupConnexion)
